// Angular
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
// NgBootstrap
import { NgbDropdownModule,  NgbTooltipModule, NgbActiveModal, NgbAlertModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
// Perfect Scrollbar
import { NgScrollbarModule } from 'ngx-scrollbar';
// Permissions directives (*ngxPermissionsOnly) — exported so ThemeModule and AuthModule (via Partials) share one import
import { NgxPermissionsModule } from 'ngx-permissions';
// Core module
import { CoreModule } from '../../core/core.module';
// CRUD Partials
import {
    ActionNotificationComponent,
    AlertComponent,
    DeleteEntityDialogComponent,
    FetchEntityDialogComponent,
    UpdateStatusDialogComponent,
    ModalAlertComponent,
    PdfViewerDialogComponent,
    PdfViewerDialogRevisedComponent,
    WeightModalAlertComponent,
    DocumentNumberDialogComponent,
    MessageHistoryDialogComponent,
    InvoiceTransmissionHistoryDialogComponent,
    InvoiceTransmissionDetailsDialogComponent
} from './content/crud';
import { DebitsCreditsProcessDialogComponent } from './content/crud/debits-credits-process-dialog/debits-credits-process-dialog.component';
import { ConfirmDialogComponent } from './content/crud/confirm-dialog/confirm-dialog.component';
import { ResendInvoiceDialogComponent } from './content/crud/resend-invoice-dialog/resend-invoice-dialog.component';
import { CustomerStatementEmailComponent } from './content/crud/customer-statement-email/customer-statement-email.component';
// Layout partials
import {
    ContextMenu2Component,
    ContextMenuComponent,
    LanguageSelectorComponent,
    NotificationComponent,
    QuickActionComponent,
    QuickPanelComponent,
    ScrollTopComponent,
    SearchDefaultComponent,
    SearchDropdownComponent,
    SearchResultComponent,
    SplashScreenComponent,
    StickyToolbarComponent,
    Subheader1Component,
    Subheader2Component,
    Subheader3Component,
    Subheader4Component,
    Subheader5Component,
    SubheaderSearchComponent,
    UserProfile2Component,
    UserProfile3Component,
    UserProfileComponent,

} from './layout';
// General
import { NoticeComponent } from './content/general/notice/notice.component';
import { PortletModule } from './content/general/portlet/portlet.module';
import { PasswordGovernanceComponent } from './content/general/password-governance/password-governance.component';
import { CompareViewComponent } from './content/general/compare-view/compare-view.component';
import { AutocompleteDropdownComponent } from './content/general/autocomplete-dropdown/autocomplete-dropdown.component';
import { AssociatorComponent } from './content/general/associator/associator.component';
import { ConfirmComponent } from './content/general/confirm-dialog/confirm-dialog.component';
import { DivisionDropdownComponent } from './content/general/division-dropdown/division-dropdown.component';
// Errpr
import { ErrorComponent } from './content/general/error/error.component';
// Extra module
import { WidgetModule } from './content/widgets/widget.module';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg';
import { CartComponent } from './layout/topbar/cart/cart.component';
// pdfjs-viewer

// Translate
import { TranslateModule } from '@ngx-translate/core';
import { PoOrdersSelectionComponent } from './content/general/po-orders-selection/po-orders-selection.component';
import { PoBatchEditComponent } from './content/general/po-batch-edit/po-batch-edit.component';
import { SingleOrderEditComponent } from './content/general/single-order-edit/single-order-edit.component';
import { CrudComponent } from './content/general/crud/crud.component';
import { RevisedInvoiceOptionsComponent } from './content/general/revised-invoice-options/revised-invoice-options.component';
import { EditMastersComponent } from './content/general/edit-masters/edit-masters.component';
import { PromptComponent } from './content/crud/prompt/prompt.component';
import { ResolveDiscrepancyModalComponent } from './content/crud/resolve-discrepancy-modal/resolve-discrepancy-modal.component';
import { NotificationDetailComponent } from './layout/topbar/notification-detail/notification-detail.component';
import { TruckReceiptEmailComponent } from './content/crud/truck-receipt-email/truck-receipt-email.component';
import { TruckReceiptEmailSelectorComponent } from './content/crud/truck-receipt-email-selector/truck-receipt-email-selector.component';
import { TruckReceiptSecondHomeEmailComponent } from './content/crud/truck-receipt-second-home-email/truck-receipt-second-home-email.component';
import { InvoiceEmailSelectorComponent } from './content/crud/invoice-email-selector/invoice-email-selector.component';
import { ConfirmationOfSalesEmailComponent } from './content/crud/confirmation-of-sales-email/confirmation-of-sales-email.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { InvoicePODialogComponent } from './content/general/invoice-po-comparinson-dialog/invoice-po-comparinson-dialog.component';
import { DebitsCreditsEDIDialogComponent } from './content/crud/debits-credits-edi-dialog/debits-credits-edi-dialog.component';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SelectPalletDialogComponent } from './content/crud/select-pallet-dialog/select-pallet-dialog.component';
import { ShowPalletDialogComponent } from './content/crud/show-pallet-dialog/show-pallet-dialog.component';
import { ShowContainerDialogComponent } from './content/crud/show-container-dialog/show-container-dialog.component';
import { ShowPalletNumbersDialogComponent } from './content/crud/show-pallet-numbers-dialog/show-pallet-numbers-dialog.component';
import { VideoDecodeComponent } from './content/general/barcode-scanner/barcode-scanner.component';
import { PoWOOrdersSelectionComponent } from './content/general/po-wo-orders-selection/po-wo-orders-selection.component';
import { WaitingDialogComponent } from './content/crud/waiting-dialog/waiting-dialog.component';
import { BoundDialogComponent } from './content/general/bond-dialog/bond-dialog.component';
import { OrderChangeDialogComponent } from './content/general/order-change-dialog/order-change-dialog.component';

// Videogular modules
import {VgCoreModule} from '@videogular/ngx-videogular/core';
import {VgControlsModule} from '@videogular/ngx-videogular/controls';
import {VgOverlayPlayModule} from '@videogular/ngx-videogular/overlay-play';
import {VgBufferingModule} from '@videogular/ngx-videogular/buffering';
import { VideoDialogComponent } from './content/general/video-dialog/video-dialog.component';
import { InvoiceNumberEDIDialogComponent } from './content/crud/invoiceNumber-edi-dialog/invoiceNumber-edi-dialog.component';


@NgModule({
    declarations: [
        ScrollTopComponent,
        NoticeComponent,
        ActionNotificationComponent,
        DeleteEntityDialogComponent,
        FetchEntityDialogComponent,
        UpdateStatusDialogComponent,
        AlertComponent,
        // topbar components
        ContextMenu2Component,
        ContextMenuComponent,
        QuickPanelComponent,
        ScrollTopComponent,
        SearchResultComponent,
        SplashScreenComponent,
        StickyToolbarComponent,
        Subheader1Component,
        Subheader2Component,
        Subheader3Component,
        Subheader4Component,
        Subheader5Component,
        SubheaderSearchComponent,
        LanguageSelectorComponent,
        NotificationComponent,
        QuickActionComponent,
        SearchDefaultComponent,
        SearchDropdownComponent,
        UserProfileComponent,
        UserProfile2Component,
        UserProfile3Component,
        CartComponent,
        ErrorComponent,
        ModalAlertComponent,
        WeightModalAlertComponent,
        PdfViewerDialogComponent,
        PdfViewerDialogRevisedComponent,
        DebitsCreditsProcessDialogComponent,
        AutocompleteDropdownComponent,
        AssociatorComponent,
        ConfirmComponent,
        ConfirmDialogComponent,
        ResendInvoiceDialogComponent,
        CustomerStatementEmailComponent,
        PasswordGovernanceComponent,
        CompareViewComponent,
        PoOrdersSelectionComponent,
        PoBatchEditComponent,
        PoWOOrdersSelectionComponent,
        CrudComponent,
        DivisionDropdownComponent,
        RevisedInvoiceOptionsComponent,
        EditMastersComponent,
        PromptComponent,
        ResolveDiscrepancyModalComponent,
        NotificationDetailComponent,
        TruckReceiptEmailComponent,
        TruckReceiptEmailSelectorComponent,
        TruckReceiptSecondHomeEmailComponent,
        InvoiceEmailSelectorComponent,
        ConfirmationOfSalesEmailComponent,
        InvoicePODialogComponent,
        DebitsCreditsEDIDialogComponent,
        SelectPalletDialogComponent,
        ShowPalletDialogComponent,
        ShowContainerDialogComponent,
        ShowPalletNumbersDialogComponent,
        VideoDecodeComponent,
        WaitingDialogComponent,
        BoundDialogComponent,
        InvoiceNumberEDIDialogComponent,
        VideoDialogComponent,
        OrderChangeDialogComponent,
        SingleOrderEditComponent,
        DocumentNumberDialogComponent,
        MessageHistoryDialogComponent,
        InvoiceTransmissionHistoryDialogComponent,
        InvoiceTransmissionDetailsDialogComponent
    ],
    exports: [
        WidgetModule,
        PortletModule,
        ScrollTopComponent,
        NoticeComponent,
        ActionNotificationComponent,
        DeleteEntityDialogComponent,
        FetchEntityDialogComponent,
        UpdateStatusDialogComponent,
        AlertComponent,
        PasswordGovernanceComponent,
        CrudComponent,
        // topbar components
        ContextMenu2Component,
        ContextMenuComponent,
        QuickPanelComponent,
        ScrollTopComponent,
        SearchResultComponent,
        SplashScreenComponent,
        StickyToolbarComponent,
        Subheader1Component,
        Subheader2Component,
        Subheader3Component,
        Subheader4Component,
        Subheader5Component,
        SubheaderSearchComponent,
        LanguageSelectorComponent,
        NotificationComponent,
        QuickActionComponent,
        SearchDefaultComponent,
        SearchDropdownComponent,
        UserProfileComponent,
        UserProfile2Component,
        UserProfile3Component,
        CartComponent,
        ErrorComponent,
        AutocompleteDropdownComponent,
        AssociatorComponent,
        ConfirmDialogComponent,
        CompareViewComponent,
        PoOrdersSelectionComponent,
        PoBatchEditComponent,
        PoWOOrdersSelectionComponent,
        DivisionDropdownComponent,
        VideoDecodeComponent,
        VideoDialogComponent,
        NgxPermissionsModule
        
    ],
    imports: [
        CommonModule,
        RouterModule,
        NgxPermissionsModule,
        FormsModule,
        ReactiveFormsModule,
        NgScrollbarModule,
        InlineSVGModule,
        CoreModule,
        PortletModule,
        WidgetModule,
        TranslateModule.forChild(),
        // angular material modules
        MatButtonModule,
        MatMenuModule,
        MatSelectModule,
        MatInputModule,
        MatTableModule,
        MatAutocompleteModule,
        MatRadioModule,
        MatIconModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatDatepickerModule,
        MatCardModule,
        MatPaginatorModule,
        MatSortModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatTabsModule,
        MatTooltipModule,
        MatDialogModule,
        MatStepperModule,
        NgbNavModule,
        NgbModule,
        // ng-bootstrap modules
        NgbAlertModule,
        NgbDropdownModule,
        NgbTooltipModule,
        PdfViewerModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule
    ],
    providers: [
        NgbActiveModal
    ]
})
export class PartialsModule {
}
